import React from 'react';
import { AlertTriangle, X, ChevronDown } from 'lucide-react';
import { DISPUTE_CATEGORIES } from '../../../../../components/serviceprovider/workerdashboard/workerbidjobs/bidjobsconstants/BidJobsConstants';

const DisputeModal = ({ onClose, onSubmit, loading }) => {
  const [category, setCategory] = React.useState('');
  const [description, setDescription] = React.useState('');

  const handleSubmit = () => {
    if (!category || !description.trim()) return;
    onSubmit({ category, description });
  };

  return (
    <div className="bj-modal-overlay" onClick={onClose}>
      <div className="bj-dispute-modal" onClick={e => e.stopPropagation()}>

        <div className="bj-dispute-modal__header">
          <div className="bj-dispute-modal__icon">
            <AlertTriangle size={20} />
          </div>
          <div>
            <h4 className="bj-dispute-modal__title">Raise a Dispute</h4>
            <p className="bj-dispute-modal__sub">Tell us what went wrong</p>
          </div>
          <button className="bj-dispute-modal__close" onClick={onClose}><X size={16} /></button>
        </div>

        <div className="bj-dispute-modal__body">

          <div className="bj-dispute-modal__field">
            <label>Issue Category</label>
            <div className="bj-dispute-modal__select-wrap">
              <select value={category} onChange={e => setCategory(e.target.value)}>
                <option value="">Select an issue...</option>
                {DISPUTE_CATEGORIES.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
              <ChevronDown size={15} className="bj-dispute-modal__chevron" />
            </div>
          </div>

          <div className="bj-dispute-modal__field">
            <label>Description</label>
            <textarea
              placeholder="Describe your issue in detail..."
              value={description}
              onChange={e => setDescription(e.target.value)}
              rows={4}
            />
          </div>

        </div>

        <div className="bj-dispute-modal__footer">
          <button className="bj-dispute-modal__cancel-btn" onClick={onClose}>Cancel</button>
          <button
            className="bj-dispute-modal__submit-btn"
            onClick={handleSubmit}
            disabled={!category || !description.trim() || loading}
          >
            {loading
              ? <span className="bj-spinner" />
              : <><AlertTriangle size={14} /> Submit Dispute</>
            }
          </button>
        </div>

      </div>
    </div>
  );
};

export default DisputeModal;